// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo___3U940","logoText":"logoText___is8Hl","header":"header___23aUm","headerLabel":"headerLabel___KJ4oE","userSettings":"userSettings___2um-L","userSettingsOpen":"userSettingsOpen___3g_Uv","avatarContainer":"avatarContainer___d3tvG","userAvatar":"userAvatar___3FnKR","userName":"userName___20Y0i","openSettings":"openSettings___1Acq_","userDropDown":"userDropDown___14T-p","settingLabel":"settingLabel___3XTFc","logoContainer":"logoContainer___3vMys"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Header/Header.module.css
// module id = 145
// module chunks = 0